import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let id = useDataValue({
    context: 'event',
    path: 'id',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return () => {
    submit({ type: 'appointmentQueue/remove', id })
  }
}
